export enum AutomationType {
    Automatic = 1,
    Manual
}

export const AutomationTypeNames = new Map<number, string>([
    [AutomationType.Automatic, 'Automatic'],
    [AutomationType.Manual, 'Manual']
]);